import roleConfig from '../../config/config.role';
import type { IRoute } from '../../config/config.route';

export interface RolePagesMap {
  [role: string]: string[];
}

const safeRole = (role?: string) => role || roleConfig.anonymous;

const canAccessRoute = (
  route: IRoute,
  role: string | undefined,
  rolePages?: RolePagesMap,
): boolean => {
  const resolvedRole = safeRole(role);
  const rolePageList = rolePages?.[resolvedRole];
  if (rolePageList && Array.isArray(rolePageList)) {
    return rolePageList.includes(route.id);
  }
  return route.authority.includes(resolvedRole);
};

export { safeRole, canAccessRoute };
